import React, { useState } from "react";
import CustomCard from "../../components/customCard";
import EastIcon from "@mui/icons-material/East";
import { useNavigate } from "react-router-dom";
import { useGeneralInfo } from "../../context/generalContext";
import { baseUrl } from "../../utills";
import CustomBackButton from "../../components/customBackButton";
import { CustomInput } from "../../components/customInput";
import { MdSearch } from "react-icons/md";
const Brands = () => {
  const navigate = useNavigate();
  const [generalInfo] = useGeneralInfo();
  const [searchTerm, setSearchTerm] = useState(""); // 🔹 State for search input

  // 🔹 Filter brands based on search input
  const filteredBrands = generalInfo?.makes?.filter((brand) =>
    brand.car_maker.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div className="px-2 md:px-6 py-2 mb-4">
      <CustomBackButton>Back</CustomBackButton>
      <div className="px-4">
        <div className="flex justify-between items-center mt-4 mb-8 md:mx-16">
          <p className="text-[18px] font-[500]">Brands</p>
          <div className="md:w-[400px]">
            <CustomInput
              placeholder="Search brand..."
              icon={<MdSearch className="text-[20px]" />}
              value={searchTerm} // 🔹 Bind input value to state
              onChange={(e) => setSearchTerm(e.target.value)} // 🔹 Update state on input change
            />
          </div>
        </div>

        {/* 🔹 Display filtered brands */}
        <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-6">
          {filteredBrands?.length > 0 ? (
            filteredBrands.map((item) => (
              <div
              className=""
                key={item.id}
                onClick={() =>
                  navigate("/car-listing", {
                    state: {
                      maker_id: item?.id,
                      name: item?.car_maker,
                    },
                  })
                }
              >
                <div className="flex justify-center items-center mb-5 bg-[#F3F3F3] w-[80px] h-[80px] rounded rounded-[100%] m-auto cursor-pointer hover hover:shadow-md">
                  <img
                    src={`${baseUrl}logos/${item?.logo}`}
                    alt={item?.logo}
                    className="w-[60px] h-[40px]"
                  />
                </div>
                <p className="text-center">{item?.car_maker}</p>
                <p className="text-center">({item?.post_count})</p>
              </div>
            ))
          ) : (
            <p className="col-span-6 text-center text-gray-500 mt-4">
              No brands found.
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default Brands;
